<route>
{
  "name": "questionAdd",
  "meta": {
    "order": 3,
    "isVisible": false,
    "iconName": "mdi-pen"
  }
}
</route>
<template>
  <div>
    <page-title
      :title="$t('pages.forms.title') + ' ' + parentItem.name">
      <v-btn
        outlined
        @click="$router.go(-1)"
        color="secondary">
        {{$t('general.back')}}
      </v-btn>
    </page-title>
    <v-form
      v-model="formIsValid"
      class="form-horizontal"
    >
      <form-item
        v-model="formData.question"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textarea"
        :rows="4"
        icon="mdi-form-textbox"
        :label="$t('models.question')"
        :placeholder="$t('models.question')"
      ></form-item>
      <form-item
        v-model="formData.description"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textarea"
        :rows="8"
        icon="mdi-form-textbox"
        :label="$t('models.description')"
        :placeholder="$t('models.description')"
      ></form-item>
      <form-item
        v-model="formData.order"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textbox"
        icon="mdi-form-textbox"
        :label="$t('models.order')"
        :placeholder="$t('models.order')"
      ></form-item>
      <span 
        class="text-h6">
        {{ $t('models.answers') }}
      </span>

      <v-card
        class="mt-5 pa-5 mb-4 form-inline answers-card"
        v-for="answer in formData.answers"
        elevation="2"
        >
        <form-item
          v-model="answer.text"
          type="textbox"
          icon="mdi-form-textbox"
          :label="$t('models.description')"
          :placeholder="$t('models.description')"
          ></form-item>
        <br/>
        <form-item
          v-model="answer.isCorrect"
          type="checkbox"
          icon="mdi-form-textbox"
          :label="$t('models.isCorrect')"
          :placeholder="$t('models.isCorrect')"
          ></form-item>
      </v-card>
      <form-action>
        <v-btn
          :disabled="!formIsValid"
          color="success"
          depressed
          @click="onSubmitForm"
        >
          {{ $t('pages.forms.submitButtonText') }}
        </v-btn>
        <v-btn
          color="secondary"
          depressed
          outlined
          @click="$router.go(-1)"
        >
          {{ $t('pages.forms.cancelButtonText') }}
        </v-btn>
      </form-action>
    </v-form>
  </div>
</template>

<script>
export default {
  layout: APP_CONFIG.layout.mainPanelLayout,
  data: () => ({
    // NOTE: Keep this name same in all form pages and components
    formIsValid: true,
    // NOTE: Keep this name same in all form pages and components
    parentItem: {},
    formData: {
      name: '',
      question: '',
      answers: [
        {
          isCorrect: false,
          text: ''
        },
        {
          isCorrect: false,
          text: ''
        },
        {
          isCorrect: false,
          text: ''
        },
        {
          isCorrect: false,
          text: ''
        }
      ],
      description: '',
      image: 'image',
      order: 0
    }
  }),
  computed: {
  },
  mounted () {
    this.preLoadData()
  },
  methods: {
    preLoadData () {
      this.$store.dispatch('chapter/getById', {
        id: this.$route.params.id
      }).then((response) => {
        this.parentItem = response.data        
      })
    },
    add () {
      this.$store.dispatch('question/add', {
        chapter: this.$route.params.id,
        name: this.formData.name,
        question: this.formData.question,
        description: this.formData.description,
        order: this.formData.order,
        answers: this.formData.answers,
        image: this.formData.image,
      }).then((response) => {
        this.$router.go(-1)
      })
    },
    onSubmitForm () {
      this.add()
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
